import { c as _c } from "react/compiler-runtime";
import { TermsPage } from "@catchy/ui";
import { getRegionConfig } from "../lib/regions/config.mjs";
const region = getRegionConfig("wellington");
export default function Terms() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <TermsPage appName={region.branding.appName} agencyName={region.publicPages.agencyName} origin={region.allowedOrigin} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}